import { Field, Int } from '@nestjs/graphql'
import { ArcClaimDto, ArcDto, ArcReviewDto, ArcReviewSiteDto } from '../arc'
import { NotificationDto } from './model.dto'
import { BaseModelDto } from '../base'
import { BookDto } from '../book'
import { ObjectType } from '@nestjs/graphql'
import { ArcTeamDto, ArcTeamMemberDto } from '../arc-team'

@ObjectType()
export class UserNotificationDto extends BaseModelDto {
  @Field(t => Int)
  status!: number

  @Field()
  statusDate!: Date

  @Field(t => Int)
  state!: number

  @Field()
  statusMessage!: string

  @Field(t => NotificationDto)
  notification!: NotificationDto

  @Field(t => BookDto, { nullable: true })
  book?: BookDto

  @Field({ nullable: true })
  nameOfInstigator?: string

  @Field(t => ArcDto, { nullable: true })
  arc?: ArcDto

  @Field(t => ArcClaimDto, { nullable: true })
  arcClaim?: ArcClaimDto

  @Field(t => ArcReviewDto, { nullable: true })
  arcReview?: ArcReviewDto

  @Field(t => ArcReviewSiteDto, { nullable: true })
  arcReviewSite?: ArcReviewSiteDto

  @Field(t => ArcTeamDto, { nullable: true })
  arcTeam?: ArcTeamDto

  @Field(t => ArcTeamMemberDto, { nullable: true })
  arcTeamMember?: ArcTeamMemberDto

  @Field(t => [String])
  params?: string[]

  @Field()
  parsedMessage!: string

  @Field()
  parsedDescription!: string

  @Field()
  to!: string
}
